import { Component } from '@angular/core';

@Component({
  selector: 'public-layout',
  templateUrl: './public.layout.html'
})
export class PublicLayoutComponent {}
